export const pluginPrefix = 'PLUGIN:E_WAIVER:';
export const SET_WAIVERS = `${pluginPrefix}SET_WAIVERS`;
export const IS_AN_ADMISSION = `${pluginPrefix}IS_AN_ADMISSION`;
export const ADD_TO_SELECTED_WAIVER = `${pluginPrefix}ADD_TO_SELECTED_WAIVER`;
export const DESELECT_WAIVER = `${pluginPrefix}DESELECT_WAIVER`;
export const RESET_SELECTED_WAIVERS = `${pluginPrefix}RESET_SELECTED_WAIVERS`;
